import service from '..';
import {GetSchoolListParams, SchoolList} from '@/service/dictionary/school';

// 验证手机号码有没有被注册
export const apiIfExistUsername = (username: string, userId?: number) =>
  service.get('/common/existusername', {
    userId, username
  });

// 查询学校列表
export const apiGetCommonSchoolList = (params: GetSchoolListParams) =>
  service.get<BackendDataWithPage<SchoolList>>('/common/school/query', params);

// 忘记密码 - 发送短息验证码
export const getMessageCode = (mobile: string) =>
  service.get<number>('/index/resetpwd/vcodesend', { mobile });

// 忘记密码 - 验证码验证
export const vaildMessageCode = (mobile: string, vcode: string) =>
  service.get('/index/resetpwd/vcodevalidate', { mobile, vcode });

// 设置新密码
export const setNewPassword = (mobile: string, vcode: string, newEncryptPwd: string) =>
  service.put('/index/resetpwd', { mobile, vcode, newEncryptPwd });

// 管理员修改密码
export const resetAdminPassword = (oldEncryptPwd: string, newEncryptPwd: string) =>
  service.put('/common/userpwd', { oldEncryptPwd, newEncryptPwd });

// 获取学年列表
export const getTermList = () =>
  service.get<Term[]>('/common/term/list');

// 学期-根据学年获取学期详情
export const getTermDetail = (termId?: number) => service.get<Term[]>('/common/term/details', {termId});

// 根据类型获取字典列表
export const getDict = (dictionaryType: string) =>
  service.get<Dictionary[]>('/common/dict/bytype', { dictionaryType });

// 根据年级获取科目清单
export const getCourseListByGrade = (gradeDcode: string) =>
  service.get<string[]>('/common/dict/courselistbygrade', { gradeDcode });
// 学生信息校验
export const validStudentInfo = (params: ValidStudentInfo) =>
  service.get('/teacher/mana/student/validate', params);

// 选型验证码登录-发送短信验证码
export const loginVcodeSend = (mobile: string) =>
  service.get<number>('/index/login/vcodesend', {mobile});
